// src/utils/posthumous.js
// Production posthume et frais de production d'une œuvre (fonte, tirage, recréation après la mort de l'artiste).
// Information saisie par le propriétaire de l'œuvre : ne qualifie ni le caractère original ni aucun droit.
export function cleanPosthumousFlag(v) {
  if (v === true || v === "true" || v === "yes") return true;
  if (v === false || v === "false" || v === "no") return false;
  return null;
}

export function cleanPosthumousYear(v) {
  if (v === null || v === undefined || String(v).trim() === "") return null;
  const n = Number(String(v).trim());
  return Number.isInteger(n) && n >= 1800 && n <= 2200 ? n : null;
}

// Montant : virgule ou point, positif ou nul, deux décimales.
export function cleanProductionCost(v) {
  if (v === null || v === undefined || String(v).trim() === "") return null;
  const n = Number(String(v).replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) / 100 : null;
}

export function cleanCurrencyCode(v) {
  const s = v == null ? "" : String(v).trim().toUpperCase();
  return /^[A-Z]{3}$/.test(s) ? s : null;
}

export function cleanText(v, max) {
  const s = v == null ? "" : String(v).trim();
  return s === "" ? null : s.slice(0, max);
}

export const POSTHUMOUS_KEYS = [
  "posthumous_production", "posthumous_production_year", "posthumous_authorized_by",
  "production_cost", "production_cost_currency", "production_notes",
];

// Applique les contrôles aux seules clés présentes dans l'objet (une fiche chargée sans ces colonnes n'est pas touchée).
export function cleanPosthumousFields(obj) {
  const out = { ...obj };
  POSTHUMOUS_KEYS.forEach((k) => { if (out[k] === undefined) delete out[k]; });
  if ("posthumous_production" in out) out.posthumous_production = cleanPosthumousFlag(out.posthumous_production);
  if ("posthumous_production_year" in out) out.posthumous_production_year = cleanPosthumousYear(out.posthumous_production_year);
  if ("posthumous_authorized_by" in out) out.posthumous_authorized_by = cleanText(out.posthumous_authorized_by, 300);
  if ("production_cost" in out) out.production_cost = cleanProductionCost(out.production_cost);
  if ("production_cost_currency" in out) out.production_cost_currency = cleanCurrencyCode(out.production_cost_currency);
  if ("production_notes" in out) out.production_notes = cleanText(out.production_notes, 2000);
  // Une année ou un responsable sans production posthume déclarée n'ont pas de sens : on ne les garde pas.
  if (out.posthumous_production !== true) {
    if ("posthumous_production_year" in out) out.posthumous_production_year = null;
    if ("posthumous_authorized_by" in out) out.posthumous_authorized_by = null;
  }
  // Un montant sans devise n'est pas exploitable : devise par défaut EUR.
  if (out.production_cost != null && "production_cost_currency" in out && !out.production_cost_currency) out.production_cost_currency = "EUR";
  return out;
}
